import { MarketConfig } from '../../types/markets/MarketConfig';

export default new MarketConfig(
  'en_VN',
  {
    fdidYouMean: false,
    ffacetNavigation: false,
    fdomainSuggestions: false,
    fvideo: false,
    fCommerceCarrossel: false,
    resultTiles: false,
    dealerWidget: false,
    frelatedsearch: false,
  },
  {
    fssInputCategory: true,
  },
  '52e440d0-0c8a-4a1e-bf1b-670a9c4a3faf',
  ''
);
